import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthSandbox } from '../sandboxes';
import { map } from 'rxjs/operators';
import { RoutesEnum } from '../enums';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  private readonly authSandbox = inject(AuthSandbox);
  private readonly router = inject(Router);

  canActivate(
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const unauthorizedMode = route.data.unauthorizedMode;
    return this.authSandbox.storeToken$.pipe(
      map((isAuthenticated) => {
        if (unauthorizedMode) {
          if (!!isAuthenticated) {
            this.router.navigate([RoutesEnum.HOME]);
          }
          return !isAuthenticated;
        } else if (!isAuthenticated) {
          this.router.navigate([RoutesEnum.LOGIN]);
        }
        return !!isAuthenticated;
      })
    );
  }
}
